<template>
  <div class="container">
    <section v-if="isMobile" class="top-section" style="padding-bottom: 20px">
      <el-button
        type="primary"
        style="width: 100% !important"
        @click="$router.push({ path: '/managers' })"
      >
        К cписку менеджеров
      </el-button>
    </section>
    <breadcrumb v-if="!isMobile" crumb="manager-add" />
    <el-row :gutter="!isMobile ? 24 : 0">
      <el-col :span="isMobile ? 24 : 18">
        <div class="my_container-card">
          <el-card class="box-card manager_add_card">
            <div v-if="!isMobile" slot="header" class="clearfix">
              <span class="my_container-card-title">
                Добавление менеджера
              </span>
            </div>
            <manager-form />
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import ManagerForm from '@/components/Forms/ManagerForm'

export default {
  name: 'ManagerAdd',
  components: { Breadcrumb, ManagerForm },
}
</script>

<style lang="sass" scoped>
.manager_add_card
  .buttons-block
     display: flex
     justify-content: flex-end
</style>
